import React from 'react';

import { Box, LinearProgress, Typography } from '@mui/material';

import { useAppTheme } from 'src/hooks/app';
import type { SxProp } from 'src/types/mui';

export const ThemeLoader: React.FC = () => {
  const { appTheme } = useAppTheme();

  return (
    <Box
      sx={containerStyles}
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      <Box display="flex" justifyContent="space-between">
        <Typography variant="h2" color={appTheme.palette.primary.main}>
          Changing Theme
        </Typography>
      </Box>

      <Box
        style={{
          width: '100%',
          marginTop: '20px',
        }}
      >
        <LinearProgress
          sx={{
            backgroundColor: appTheme.palette.secondary.main,
          }}
        />
      </Box>
    </Box>
  );
};

const containerStyles: SxProp = {
  margin: '20px auto',
  height: '100vh',
  maxWidth: '60%',
};
